var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "211642_checkmark_circled_icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91650",
    d: "M40 32a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm4.1 5.325L39.136 43.7c-.039.039-.1.125-.182.125a.263.263 0 0 1-.182-.1c-.046-.046-2.818-2.711-2.818-2.711l-.054-.054a.186.186 0 0 1 0-.229.467.467 0 0 0 .039-.043c.275-.289.832-.875.868-.911s.086-.107.171-.107.146.075.189.118 1.607 1.546 1.607 1.546l3.975-5.107a.2.2 0 0 1 .125-.05.2.2 0 0 1 .125.046l1.093.861a.2.2 0 0 1 .046.125.185.185 0 0 1-.038.116z",
    style: {
      fill: "#76a9fa"
    },
    transform: "translate(-32 -32)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.svg";
export { ForwardRef as ReactComponent };